const Tables = () => import("@/views/base/Tables");
const OEM = () => import("@/views/base/OemRepair.vue");
const BER = () => import("@/views/base/ber.vue");
const EOL = () => import("@/views/base/eol.vue");
const NTF = () => import("@/views/base/ntf.vue");
const WAR = () => import("@/views/base/war.vue");
const TAT = () => import("@/views/base/tat.vue");
const AnalyticsByModel = () => import("@/views/base/AnalyticsByModel.vue");
const Backlog = () => import("@/views/base/ActiveBacklog.vue");
const Office = () => import("@/views/base/Office.vue");
const OfficeCharts = () => import("@/views/base/OfficeCharts.vue");
const Received = () => import("@/views/base/Received.vue");
const TableAllData = () => import("@/views/base/TableAllData.vue");
const TableAllDataC = () => import("@/views/base/TableAllDataC.vue");
const ModelView = () => import("@/views/base/Model");

const techStatisticsRoutes = {
  mainRoute: "base/Backlog",
  children: [
    {
      path: "analyticsByModel",
      name: "AnalyticsByModel",
      component: AnalyticsByModel
    },
    {
      path: "base/BER",
      name: "BER",
      component: BER
    },
    {
      path: "base/EOL",
      name: "EOL",
      component: EOL
    },
    {
      path: "base/NTF",
      name: "NTF",
      component: NTF
    },
    {
      path: "base/WAR",
      name: "WAR",
      component: WAR
    },
    {
      path: "base/TAT",
      name: "TAT",
      component: TAT
    },
    {
      path: "base/OemRepair",
      name: "OEM",
      component: OEM
    },
    {
      path: "base/Backlog",
      name: "Active Backlog",
      component: Backlog
    },
    {
      path: "base/Office",
      name: "Active Backlog",
      component: Office
    },
    {
      path: "base/OfficeCharts",
      name: "OfficeCharts",
      component: OfficeCharts
    },
    {
      path: "base/Received",
      name: "Received Equipment",
      component: Received
    },
    {
      path: "base/Tables",
      name: "Tables",
      component: Tables,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/TableAllData",
      name: "TableAllData",
      component: TableAllData,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/TableAllDataC",
      name: "TableAllDataC",
      component: TableAllDataC,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "model",
      name: "Model",
      component: ModelView,
      props(route) {
        return route.query || {};
      }
    }
  ]
};

export default techStatisticsRoutes;
